export const environment = {
    // Staging is a deployed (optimized) build, but kept verbose for diagnostics:
    // auth.config.ts logs at Warn when `production` is false. Set true to quiet it.
    production: false,
    /** Environment name for the rail footer badge (shell `<eg-rail [env]>`): 'lokalno' | 'staging' | '' — an empty name renders no badge, which is production. */
    name: 'staging',

    // Optional UI URL overrides; empty values use the current user's registered Identity UI clients.
    // Access and the seven-application catalog are enforced by @expertgroup/shell.
    ecosystem: {
        protax: '',
        reporting: '',
        ticketing: '',
        internalgpt: '',
        identity: ''
    },

    /** HotChocolate GraphQL admin API — staging Identity server */
    graphqlEndpoint: 'https://staging.api.identity.expertgroup.rs/graphql',
    /** OIDC issuer / authority — staging Identity server */
    issuer: 'https://staging.api.identity.expertgroup.rs',

    /** Public SPA OAuth client in the staging Identity database; Address matches the callbacks below. */
    clientId: 'ExpertGroup-identity-ui',
    /** Only openid + offline_access are honored by the backend user flow */
    scope: 'openid offline_access',
    redirectUrl: 'https://staging.identity.expertgroup.rs/',
    postLogoutRedirectUri: 'https://staging.identity.expertgroup.rs/',
    /** Identity SignalR host — the service-graph hub lives at `${signalrBase}/hubs/service-graph`. */
    signalrBase: 'https://staging.api.identity.expertgroup.rs',
    /** Provider key used by self-service Microsoft account linking. */
    externalIdentity: {
        // Empty on purpose: the server then picks the signed-in tenant's ONLY offered provider (ADR 0007, a blank key
        // resolves when the tenant is offered exactly one). A fixed key here had to match each tenant's mapping by hand
        // ('entra-eg' against the seeded 'Entra'). A tenant offered two or more providers cannot Connect until a picker exists.
        microsoftConnectProviderKey: ''
    },
    /** Service-graph dashboard ("Ekosistem servisa"). */
    serviceGraph: {
        /** Force the client-side simulated glide feed (demo the screen without the backend hub running). */
        simulated: false
    }
};
